import styled, { css } from "styled-components";
import tw from "twin.macro";

import { BoxSizingStyle } from "../../BoxSizingStyle";
import { FontStyle } from "../../FontStyle";

export const StyledOption = styled.li<{ hover?: boolean }>`
  ${tw`tw-select-none tw-font-normal`}
  font-size: 14px;
  display: flex;
  justify-content: space-between;
  height: 28px;
  padding-left: 16px;
  padding-right: 16px;
  margin-top: 4px;
  margin-bottom: 4px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: space-between;
  transition-duration: 0.1s;
  color: var(--color-theme-900);

  ${FontStyle}
  ${BoxSizingStyle}

  ${(props) =>
    props.hover &&
    css`
      background-color: var(--color-theme-200);
    `}
`;

StyledOption.displayName = "StyledOption";
